import config from 'Config/AppConfig'

export const redirectToWorkforceIntelligence = () => {
    const url = config.api.WorkforceIntelligence
    const _linkElement = document.createElement('a')
    _linkElement.href = url
    _linkElement.target = '_blank'
    _linkElement.rel = 'noopener noreferrer'
    _linkElement.click()
}

export const redirectToLogAnalyzer = (accessToken, logAnalyzerParam) => {
    if (logAnalyzerParam) {
        const form = document.createElement('form');
        form.method = 'POST';
        form.action = config.api.logAnalyzerNgURL;
        form.target = '_blank';

        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'accessToken';
        input.value = accessToken;

        form.appendChild(input);
        document.body.appendChild(form);
        form.submit();
        document.body.removeChild(form);
    } else {
        const url = `${config.api.logAnalyzerURL}?accessToken=${accessToken}`;
        const _linkElement = document.createElement('a');
        _linkElement.href = url;
        _linkElement.target = '_blank';
        _linkElement.rel = 'noopener noreferrer';
        _linkElement.click();
    }
}

export const redirectToNewExperience = (accessToken, local) => {
    
      
  const url = config.api.newExperienceURL;
  const win = window.open(url, '_blank'); 

  if (win) {
    const maxRetries = 15;
    let attempt = 0;

    const sendToken = () => {
      try {
        win.postMessage({ accessToken }, '*');
      } catch (error) {
        console.error(`Sending token attempt ${attempt + 1} failed`, error);
      }

      attempt++;
      if (attempt < maxRetries) {
        setTimeout(sendToken, 1000); // retry after 1 second
      }
    };

    setTimeout(sendToken, 1000); // initial delay
  } else {
    console.error('Failed to open window for New Experience.');
  }
}